import api from '../config/api'

interface Response {
    token: string,
    user: {
        id: number,
        name: string,
        email: string,
        branch_id: number,
        role: string | null
    }
}

interface LoginProps {
    email: string
    password: string
}


export async function signIn({ email, password }: LoginProps) {
    try {
        const loginResponse = await api.post<Promise<Response>>('/authenticate', {
            email,
            password
        })
        const { token, user } = await loginResponse.data

        return { token, user }

    } catch (err) {
        return null
    }
}